import React from "react";
import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const Certificates = React.lazy(() => import("@mediaspace/features/certificates"));

export const render = getDsLayoutComponentRenderer(Certificates);
